





































































import Vue from "vue"
import PProjectList, {
  ClickFavoriteIconEmitArgument,
} from "./local/PProjectList.vue"
import CMobileSearchKit from "./local/CMobileSearchKit.vue"
import PPcSearchKit from "./local/PPcSearchKit.vue"
import CPcBanner from "~/components/custom/banner/CPcBanner.vue"
import CMobileBanner from "~/components/custom/banner/CMobileBanner.vue"
import CProjectCreateButton from "~/components/custom/projectActionButton/CProjectCreateButton.vue"
import {
  UniversalWriteAcl,
  UniversalReadAcl,
  ParticularWriteAcl,
} from "~/config/acl/accessControlList"
import Container, {
  EmitArgumentOfScroll,
} from "~/components/guideline/frame/Container.vue"
import CSignUpStaticAlert from "~/components/custom/alert/CSignUpStaticAlert.vue"
import { ProjectView } from "~/backendApis/viewModel"
import { SearchParams } from "~/clStores/projectSearchList"
import CShouldApealPaidPlanAlert from "~/components/custom/alert/CShouldApealPaidPlanAlert.vue"

export default Vue.extend({
  components: {
    Container,
    CSignUpStaticAlert,
    CMobileSearchKit,
    PProjectList,
    CProjectCreateButton,
    PPcSearchKit,
    CPcBanner,
    CMobileBanner,
    CShouldApealPaidPlanAlert,
  },
  data() {
    return {
      isShownShouldApealPaidPlanContract: false,
    }
  },
  computed: {
    isAccessibleRequireAuthenticationResources(): boolean {
      return this.$clAuth.hasPermission(
        UniversalReadAcl.REQUIRE_AUTHENTICATION_RESOURCES
      )
    },
    jobCategoryOptions() {
      return this.$clStores.projectSearchParameterOption.getters
        .jobCategoryOptions
    },
    possibleOperatingHourOptions() {
      return this.$clStores.projectSearchParameterOption.getters
        .possibleOperatingHourOptions
    },
    workingFormOptions() {
      return this.$clStores.projectSearchParameterOption.getters
        .workingFormOptions
    },
    searchSortOptions() {
      return this.$clStores.projectSearchParameterOption.getters
        .searchSortOptions
    },
    projects(): ProjectView[] {
      return this.$clStores.projectSearchList.getters.projects
    },
    defaultOffsetTop(): number {
      const path = this.$route.path
      return this.$clStores.scrollPosition.getters.getOffsetTop(path)
    },
    isVisibleCreateProjectButton(): boolean {
      return (
        this.$clAuth.hasPermission(
          UniversalWriteAcl.AUTHENTICATED_CORPORATION_RESOURCES
        ) && this.$clAuth.hasPermission(ParticularWriteAcl.PROJECT_CREATE)
      )
    },
    searchKitParams: {
      get(): SearchParams {
        return this.$clStores.projectSearchList.getters.searchParams
      },
      set(newParams: SearchParams): void {
        this.$clStores.projectSearchList.actions.updateSearchParams(newParams)
      },
    },
    favoriteProjectIds() {
      return this.$clStores.favoriteProjectList.getters.getIdList()
    },
    canFetchNextPage(): boolean {
      return this.$clStores.projectSearchList.getters.canFetchNextPage
    },
    shouldApealPaidPlanContract(): boolean {
      return (
        this.$clAuth.hasPermission(
          UniversalWriteAcl.AUTHENTICATED_CORPORATION_RESOURCES
        ) &&
        this.$clStores.corporationContractAppeal.getters
          .shouldApealPaidPlanContract
      )
    },
  },
  watch: {
    "$clAuth.finishedAuthProcess": {
      handler(isFinishedAuthProcess) {
        if (isFinishedAuthProcess && this.$clAuth.loggedIn) {
          this.$clStores.favoriteProjectList.actions.refreshList()
        }
        if (this.$clAuth.corporationId) {
          this.$clStores.corporationContractAppeal.actions.refresh()
        }
      },
      immediate: true,
    },
  },
  beforeMount() {
    if (!this.$clStores.projectSearchList.getters.exists) {
      this.fetchNewProjects()
    }

    this.$clStores.projectSearchParameterOption.actions.loadParameter()
  },
  methods: {
    updateOffsetOfPage({ offsetTop }: EmitArgumentOfScroll) {
      this.$clStores.scrollPosition.actions.setOffsetTop({
        path: this.$route.path,
        offsetTop,
      })
    },
    fetchNewProjects() {
      this.$clStores.projectSearchList.actions.fetchNew()
      this.$gtag(
        "event",
        "projects_search",
        this.$clStores.projectSearchList.getters.searchParams
      )
    },
    fetchNextPage() {
      this.$clStores.projectSearchList.actions.fetchNextPage()
    },
    toggleFavoriteStatus({ projectId }: ClickFavoriteIconEmitArgument) {
      this.$gtag("event", "click_project_favorite", {
        projectId,
        isFavorited: !this.favoriteProjectIds.includes(projectId),
      })
      this.$clStores.favoriteProjectList.actions.toggleFavoriteStatus(projectId)
    },
    updateIsShownShouldApealPaidPlanContract() {
      this.isShownShouldApealPaidPlanContract = !this
        .isShownShouldApealPaidPlanContract
    },
  },
})
